import React from 'react'
import './About.css'

import prashantimg from '../../assets/prash.jpg'
const About = () => {
  return (
    <div id='about' className='about'>
        <div className="about-title">
            <h1>About me</h1>
           
        </div>
        <div className="about-sections">
            <div className="about-left">
                  <img src={prashantimg} alt="" />
            </div>
            <div className="about-right">
                <div className="about-para">
                      <p>I am a passionate full-stack developer skilled in HTML, CSS, JavaScript, PHP, and Bootstrap. Currently pursuing BTech(Computer Science and Engineering)</p>
                      <p>My passion for Web development is not only reflected in my extensive experiences but also in the enthusiasm and dedication I bring to each project.</p>
                </div>
                <div className="about-skills">
                    <div className="about-skill">
                        <p>HTML & CSS</p><hr style={{width:"80%"}} />
                    </div>
                    <div className="about-skill">
                        <p>React JS</p><hr style={{width:"60%"}} />
                    </div>
                    <div className="about-skill">
                        <p>JavaScript</p><hr style={{width:"50%"}} />
                    </div>
                    <div className="about-skill">
                        <p>Bootstrap</p><hr style={{width:"80%"}} />
                    </div>
                    <div className="about-skill">
                        <p>PHP</p><hr style={{width:"50%"}} />
                    </div>
                </div>
            </div>        
                
        </div>
      {/* <div className="about-achievements">
        <div className="about-achievement">
            <h1>10+</h1>
            <p>PROJECT COMPLETED</p>
        </div>
        <hr /> 

      </div>*/}
    </div>
  )
}

export default About
